module.exports = __webpack_public_path__ + "img/users.b7866b74.svg";